// extracted by mini-css-extract-plugin
export default {"versionNumber":"NnexTx","whiteFont":"jw7lgx"};